import type { FlowTask } from '@Types/flowTask.interface';
import { AuthFlowType } from '@Enums/authFlowType.enum';
import _ from 'lodash';


export const FLOW_DEFINITIONS: Record<AuthFlowType, FlowTask[]> = {
    [AuthFlowType.VerifyPasscode]: [
        { routeName: "enter-phone" },
        { routeName: "verify-passcode" },
    ],
    [AuthFlowType.VerifyPhoneOtp]: [
        { routeName: "verify-phone" },
        { routeName: "verify-passcode" },
    ],
    [AuthFlowType.VerifyEmailCode]: [
        { routeName: "verify-email-code" },
    ],
    [AuthFlowType.ChannelSelection]: [
        { routeName: "channel-selection" },
    ],
    [AuthFlowType.KnowYourClient]: [
        { routeName: "verify-identity" }
    ],
    [AuthFlowType.Stop]: [
        { routeName: "unable-to-process" }
    ],
    [AuthFlowType.Pause]: [
        { routeName: "pause" }
    ],
    [AuthFlowType.IdentityVerification]: [
        { routeName: "verify-identity-instructions" },
        { routeName: "identity-doc-type" }
    ],
    [AuthFlowType.IdentityVerificationMobile]: [
        { routeName: "identity-doc-type" }
    ],
    [AuthFlowType.IdentityVerificationComplete]: [
        { routeName: "identity-complete" }
    ],
    [AuthFlowType.KnowledgeBasedAuthentication]: [
        { routeName: "kba-primer" },
        { routeName: "kba-details" },
        { routeName: "kba-questions" },
    ],
    [AuthFlowType.DisableVpn]: [
        { routeName: "disable-vpn" },
    ],
};

// todo: move this somewhere?! :)
export const isAuthFlowType = (val: string): val is AuthFlowType => {
    return _.includes(_.values(AuthFlowType), val);
};